import { DataScope } from './../../../../../core/models/data-scope';
import { SortOrder } from 'src/app/core/interface/sort-order';
import { Page } from "src/app/core/models/page";
import { OrderQueryScopeEnum } from 'src/app/core/enums/order-query-scope.enum';
export class AdvisingAbnormalTableHeaderGetRequest extends Page {
  orderQueryScope: OrderQueryScopeEnum;
  userEmail: string;
  facilities: string[] | null;
  vendorNumber: string[] | null;
  hawbNo: string[] | null;
  adNo: string[] | null;
  invoiceNo: string[] | null;
  notified: number;
  replied: number;
  userDataScopes: DataScope[];
  sortOrder: SortOrder | null;
  roleCodes: string[] | null;
  userType: string | null;
  pcsrAndCsrList: string[] | null;

  constructor() {
    super();
    this.orderQueryScope = OrderQueryScopeEnum.personal;
    this.userEmail = '';
    this.facilities = null;
    this.vendorNumber = null;
    this.hawbNo = null;
    this.adNo = null;
    this.invoiceNo = null;
    this.notified = 0;
    this.replied = 0;
    this.userDataScopes = [];
    this.sortOrder = null;
    this.roleCodes = null;
    this.userType = null;
    this.pcsrAndCsrList = null;
  }
}
